<template>
  <Button :type="type" @click="func" :loading="loading">
    <slot>{{ title }}</slot>
  </Button>
</template>
<script>
export default {
  name: 'auto-button',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    method: {
      type: Function,
      default: () => void 0,
    },
    title: {
      type: String,
      default: '保存',
    },
    exam: {
      type: [Function, null],
      default: null,
    },
    // size: {
    //   type: String,
    //   default: '',
    // },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async func() {
      let flag = true
      if (this.exam) {
        flag = this.exam()
        if (flag instanceof Promise) {
          flag = await flag
        }
      }
      if (flag) {
        this.loading = true
        try {
          await this.method()
        } catch (error) {
          console.log('AutoConsole: func -> error', error)
        } finally {
          this.loading = false
        }
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Base/auto-button.vue